import * as log from './log';

export const stackExtractor = (fake: unknown) => {
  let who = '[?]';

  if (
    fake &&
    typeof fake === 'object' &&
    'stack' in fake &&
    fake.stack &&
    typeof fake.stack === 'string'
  ) {
    const stack = fake.stack.split('\n');

    try {
      let myWho = '[';
      const myAtLine = stack[2]?.split('at ')[1];
      const myParts = myAtLine?.split(' ') ?? [];
      let [fileInfo] = myParts;

      if (myParts.length === 2) {
        myWho += `${myParts[0]} `;
        [, fileInfo] = myParts;
      }

      // just get the last 2 paths
      const fileParts = fileInfo?.split('/') ?? [];
      const file = `${fileParts[fileParts.length - 2]}/${fileParts[fileParts.length - 1]}`;

      myWho += `${file.split(')')[0]}']'`;
      who = myWho;
    } catch (e: unknown) {
      log.debug('stackExtractor', 'Error extracting stack trace', JSON.stringify(e));
    }
  }

  return who;
};
